module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_7.f2119466.png";